export default __webpack_public_path__ + "static/media/Needles of the Freezing Gale.af07a430.jpg";